// extracted by mini-css-extract-plugin
export var tosLink = "_du-0";